export default "__VITE_ASSET__D4qGJwC4__"